import { App } from "antd";
import { useTranslation } from "react-i18next";
import type { PickTable } from "../logic/newReservation";
import type { NewReservationForm } from "./useNewReservationForm";

/**
 * „☆ Предложи маса" — общо за панела в „Резервации" и модала в „Таблица на
 * резервациите": докато заетостта на деня не е ясна — съобщение вместо избор;
 * иначе избира най-малката подходяща маса (`form.suggest`) и вика
 * `onFound` (показва региона ѝ), а без такава — предупреждение.
 */
export const useSuggestTable = (form: NewReservationForm) => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  return (activeRegionId: number | null, onFound: (table: PickTable) => void) => {
    if (form.isLoadingDay) {
      message.info(t("reservations.form.dayLoading"));
      return;
    }
    if (form.dayError) {
      message.error(t("reservations.form.dayError"));
      return;
    }
    const table = form.suggest(activeRegionId);
    if (table) onFound(table);
    else message.warning(t("reservations.form.noSuggestion", { count: form.draft.guests }));
  };
};
